import gql from 'graphql-tag';

export const createTeamMutation = gql`
	mutation CreateTeam($input: TeamInput) {
		createTeam(input: $input) {
			id
			name
			slug
			isActive
			captain {
				id
				name
				slug
				username
				email
			}
			coCaptain {
				id
				name
				slug
				username
				email
			}
			league {
				id
				name
				slug
				type
			}
			location {
				id
				name
				slug
			}
			divisions {
				id
				name
				slug
			}
			players {
				id
				name
				username
			}
			# description
			# type
			# isActive
		}
	}
`;
